import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../utils/types";
import { getTask, learnerSubmitTask } from "../../../../redux/educator/actions";
import {
  selectTasks,
  selectTasksLoaded,
  selectTasksLoading,
} from "../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  tasks: selectTasks(state),
  loading: selectTasksLoading(state),
  loaded: selectTasksLoaded(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getTask,
      learnerSubmitTask,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
